import React, { useEffect } from 'react';
import OneSignal from 'onesignal-cordova-plugin';
import appConfig from '@/utils/config';
import { isFromApp } from '@/biz/tool';

interface Props {}

const canUseOneSignalCordova = () => {
  const globalObj = window as any;
  const hasCordovaRuntime = Boolean(globalObj?.cordova);
  const hasOneSignalApi =
    typeof (OneSignal as any)?.initialize === 'function' &&
    typeof (OneSignal as any)?.Debug?.setLogLevel === 'function' &&
    typeof (OneSignal as any)?.Notifications?.requestPermission === 'function';

  return hasCordovaRuntime && hasOneSignalApi;
};

const OneSignalConfig: React.FC<Props> = ({}) => {
  const fromApp = isFromApp();
  useEffect(() => {
    if (!fromApp) return;
    if (!canUseOneSignalCordova()) return;

    try {
      // Enable verbose logging for debugging (remove in production)
      OneSignal.Debug.setLogLevel(6);
      // Initialize with your OneSignal App ID
      OneSignal.initialize(appConfig.oneSignalAppId);
      // Use this method to prompt for push notifications.
      // We recommend removing this method after testing and instead use In-App Messages to prompt for notification permission.
      OneSignal.Notifications.requestPermission(false).then(
        (accepted: boolean) => {
          console.log('User accepted notifications: ' + accepted);
        }
      );
    } catch (error) {
      console.warn('OneSignal initialization skipped:', error);
    }
  }, [fromApp]);

  return null;
};

export default OneSignalConfig;
